// extracted by mini-css-extract-plugin
module.exports = {"subtotal":"Subtotal_subtotal__6SYBv","subtotal__gift":"Subtotal_subtotal__gift__zQzdN"};